import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'store';

import { initialState } from './customerFeedback.types';
import { customerFeedbackApi } from './customerFeedbackApi';

const customerFeedbackSlice = createSlice({
  extraReducers: (builder) => {
    builder.addMatcher(
      customerFeedbackApi.endpoints.getCustomerFeedbacks.matchFulfilled,
      (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.info = action.payload.info;
        }
      }
    );
  },
  initialState: initialState,
  name: 'customerFeedback',
  reducers: {}
});

export const selectCustomerFeedback = (state: RootState) => state.customerFeedback;

export default customerFeedbackSlice.reducer;
